import React, {ChangeEvent} from "react";
import {cnDetailSettingsMenu, IDetailSettingsMenuGroupProps} from "./DetailSettingsMenu";
import {useTranslation} from "react-i18next";
import {IHandleData} from "../../../../../common-code/interfaces/materials/IHandleData";
import {useSelector} from "react-redux";
import {AppState} from "../../../../redux/AppStore";
import {IDetailRebuildMethods} from "../../../../interfaces/settingData/IDetailRebuildMethods";
import {
    ALIGN_BOTTOM,
    ALIGN_CENTER,
    ALIGN_LEFT,
    ALIGN_RIGHT, ALIGN_TOP,
    HANDLE_ID_NONE, HANDLE_TYPE_HORIZONTAL, HANDLE_TYPE_VERTICAL,
    LEVEL_TOP
} from "../../../../../common-code/constants";
import {TAlign} from "../../../../../common-code/types/TAlign";
import {THandleType} from "../../../../../common-code/types/handle/THandleType";
import {IDetailMargin} from "../../../../../common-code/interfaces/geometry/IDetailMargin";
import {THandlePositionInfo} from "../../../../../common-code/types/handle/THandlePositionInfo";
import {TFacadeSizes} from "../../../../../common-code/types/TFacadeSizes";
import {ObjectSelect} from "../../../components/ObjectSelect/ObjectSelect";
import {OBJECT_SELECT_TYPE_HANDLE} from "../../../../constants";
import {IMaterialData} from "../../../../../common-code/interfaces/materials/IMaterialData";
import {IFacadeMaterialData} from "../../../../../common-code/interfaces/materials/IFacadeMaterialData";
import {ISettingGroupDetailHandle} from "../../../../interfaces/settingData/ISettingGroupDetailHandle";
import {ICreateObjectData} from "../../../../../common-code/interfaces/createData/ICreateObjectData";
import {Select} from "../../../components/Select/Select";
import {RangeNumber} from "../../../components/RangeNumber/RangeNumber";
import {Tumbler} from "../../../components/Tumbler/Tumbler";

export interface IDetailSettingsMenuHandleGroupProps extends IDetailSettingsMenuGroupProps {
    handleData: ISettingGroupDetailHandle;
    createUnit?: ICreateObjectData;
}

export const DetailSettingsMenuHandle: React.FC<IDetailSettingsMenuHandleGroupProps> =
    ({
        data,
         handleData,
         service,
         className,
         onRebuildData,
         createUnit,
     }) => {

        const {t} = useTranslation();
        const handles: IHandleData[] | undefined = useSelector((state: AppState) => state.wizard.handles);
        const bottomHandle: IHandleData | undefined = useSelector((state: AppState) => state.wizard.bottomHandle);
        const topHandle: IHandleData | undefined = useSelector((state: AppState) => state.wizard.topHandle);
        const toggleHasCustomPosition = (event: ChangeEvent<HTMLInputElement>) => {
            onRebuildData(
                'setHandleCustomPosition' as keyof IDetailRebuildMethods,
                handleData.detailId,
                handleData.unitId,
                {hasCustomPosition: event.target.checked}
            );
        }
        const changeHandleModelId = (handle: IHandleData,) => {
            onRebuildData(
                'setHandleModelId' as keyof IDetailRebuildMethods,
                handleData.detailId,
                handleData.unitId,
                {handle: handle, facade: handleData.facadeData}
            );
        }
        const toggleHandleNone = (isNone: boolean) => {
            const levelHandle: IHandleData | undefined = handleData.level === LEVEL_TOP ? topHandle : bottomHandle;
            const handle: IHandleData = (isNone || !levelHandle) ? {
                id: HANDLE_ID_NONE,
                title: t('Без ручки'),
                models: [],
            } : levelHandle
            onRebuildData(
                'setHandleModelId' as keyof IDetailRebuildMethods,
                handleData.detailId,
                handleData.unitId,
                {handle: handle, facade: handleData.facadeData}
            );
        }
        const changeHandleAlign = (name: 'x' | 'y', value: TAlign) => {
            onRebuildData(
                'setHandleCustomPosition' as keyof IDetailRebuildMethods,
                handleData.detailId,
                handleData.unitId,
                {
                    positionInfo: {
                        ...handleData.customPosition,
                        align: {
                            ...handleData.customPosition.align,
                            [name]: value
                        }
                    }
                }
            );
        }
        const changeHandleLocation = (value: THandleType) => {
            onRebuildData(
                'setHandleCustomPosition' as keyof IDetailRebuildMethods,
                handleData.detailId,
                handleData.unitId,
                {
                    positionInfo: {
                        ...handleData.customPosition,
                        location: value
                    }
                }
            );
        }
        const changeHandleMargin = (name: 'x' | 'y' | 'z', value: number) => {
            const margin: IDetailMargin = handleData.customPosition.margin ? handleData.customPosition.margin : {};

            onRebuildData(
                'setHandleCustomPosition' as keyof IDetailRebuildMethods,
                handleData.detailId,
                handleData.unitId,
                {
                    positionInfo: {
                        ...handleData.customPosition,
                        margin: {...margin, [name]: value}
                    }
                }
            );
        }
        const positionInfo: THandlePositionInfo = handleData.hasCustomPosition ? handleData.customPosition : handleData.autoPosition;
        const facadeSizes: TFacadeSizes = handleData.facadeData.sizes || {width: 1000, height: 1000};

        return (<div className={cnDetailSettingsMenu('Handle', [className])}>
            <div className={cnDetailSettingsMenu('Title')}>{t('Ручка ') + '№:' + data.id}</div>
            <Tumbler checked={handleData.isDelete}
                     name={'notHandle'}
                     callBack={(event: ChangeEvent<HTMLInputElement>) => {
                         toggleHandleNone(event.target.checked);
                     }}
                     label={t('Удалить ручку')}
                     className={cnDetailSettingsMenu('Checkbox')}
            />
            {handleData.isDelete || <>
                {handles && service.canChangeHandles() ? <ObjectSelect
                    className={cnDetailSettingsMenu('ModelId')}
                    type={OBJECT_SELECT_TYPE_HANDLE}
                    data={{type: OBJECT_SELECT_TYPE_HANDLE, object: handleData.handleData, createUnit: createUnit}}
                    list={handles}
                    title={t('Ручка') || ''}
                    // openInModal={true}
                    // closeModalOnSelect={true}
                    onSelectObject={(handle: IMaterialData | IFacadeMaterialData) => {
                        changeHandleModelId(handle as IHandleData);
                    }}
                    // parentFacadeMaterial={handleData.facadeMaterial}
                    service={service}
                    level={createUnit?.level}
                /> : null}
                <Tumbler checked={handleData.hasCustomPosition}
                         name={'hasCustomPosition'}
                         callBack={toggleHasCustomPosition}
                         label={t('Установить вручную')}
                         className={cnDetailSettingsMenu('Checkbox')}
                />
                <div className={cnDetailSettingsMenu('Group', {active: !handleData.hasCustomPosition})}>
                    <div className={cnDetailSettingsMenu('EditGroup')}>
                        <div className={cnDetailSettingsMenu('SubTitle')}>{t('Расположение на фасаде')}:</div>
                        <div className={cnDetailSettingsMenu('Item')}>
                            <div className={cnDetailSettingsMenu('SelectTitle')}>
                                {t('По горизонтали')}:
                            </div>
                            <Select placeholder={t('По горизонтали') + ':'}
                                    options={[
                                        {value: ALIGN_LEFT, content: 'Слева'},
                                        {value: ALIGN_CENTER, content: 'По центру'},
                                        {value: ALIGN_RIGHT, content: 'Справа'},
                                    ]}
                                    value={positionInfo.align.x || ''}
                                    callBack={(event: ChangeEvent<HTMLSelectElement>) => {
                                        changeHandleAlign('x', event.target.value as TAlign);
                                    }}
                                    disabled={!handleData.hasCustomPosition}
                            />
                        </div>
                        <div className={cnDetailSettingsMenu('Item')}>
                            <div className={cnDetailSettingsMenu('SelectTitle')}>
                                {t('По вертикали')}:
                            </div>
                            <Select placeholder={t('По вертикали') + ':'}
                                    options={[
                                        {value: ALIGN_BOTTOM, content: 'Снизу'},
                                        {value: ALIGN_CENTER, content: 'По центру'},
                                        {value: ALIGN_TOP, content: 'Сверху'},
                                    ]}
                                    value={positionInfo.align.y || ''}
                                    callBack={(event: ChangeEvent<HTMLSelectElement>) => {
                                        changeHandleAlign('y', event.target.value as TAlign);
                                    }}
                                    disabled={!handleData.hasCustomPosition}
                            />
                        </div>
                    </div>
                    <div className={cnDetailSettingsMenu('EditGroup')}>
                        <div className={cnDetailSettingsMenu('Item')}>
                            <div className={cnDetailSettingsMenu('SelectTitle')}>
                                {t('Положение')}:
                            </div>
                            <Select placeholder={t('Положение') + ':'}
                                    options={[
                                        {value: HANDLE_TYPE_HORIZONTAL, content: 'Горизонтальное'},
                                        {value: HANDLE_TYPE_VERTICAL, content: 'Вертикальное'},
                                    ]}
                                    value={positionInfo.location}
                                    callBack={(event: ChangeEvent<HTMLSelectElement>) => {
                                        changeHandleLocation(event.target.value as THandleType);
                                    }}
                                    disabled={!handleData.hasCustomPosition}
                            />
                        </div>
                    </div>
                    <div className={cnDetailSettingsMenu('EditGroup')}>
                        <div className={cnDetailSettingsMenu('SubTitle')}>{t('Отступ')}:</div>
                        <div className={cnDetailSettingsMenu('Item')}>
                            <div className={cnDetailSettingsMenu('SelectTitle')}>
                                {t('По горизонтали')}:
                            </div>
                            <RangeNumber min={-facadeSizes.width} max={facadeSizes.width}
                                         value={positionInfo.margin.x !== undefined && !isNaN(+positionInfo.margin.x) ?
                                             +positionInfo.margin.x : 0}
                                         disabled={!handleData.hasCustomPosition}
                                         callBack={(value: number) => {
                                             changeHandleMargin('x', value);
                                         }}
                                         name="marginX"
                                         viewControl={true}
                                         className={cnDetailSettingsMenu('Range')}
                                         showSlider={false}
                            />
                        </div>
                        <div className={cnDetailSettingsMenu('Item')}>
                            <div className={cnDetailSettingsMenu('SelectTitle')}>
                                {t('По вертикали')}:
                            </div>
                            <RangeNumber min={-facadeSizes.height} max={facadeSizes.height}
                                         value={positionInfo.margin.y !== undefined && !isNaN(+positionInfo.margin.y) ?
                                             +positionInfo.margin.y : 0}
                                         disabled={!handleData.hasCustomPosition}
                                         callBack={(value: number) => {
                                             changeHandleMargin('y', value);
                                         }}
                                         name="marginY"
                                         viewControl={true}
                                         className={cnDetailSettingsMenu('Range')}
                                         showSlider={false}
                            />
                        </div>
                        <div className={cnDetailSettingsMenu('Item')}>
                            <div className={cnDetailSettingsMenu('SelectTitle')}>
                                {t('По глубине')}:
                            </div>
                            <RangeNumber min={-100} max={100}
                                         value={positionInfo.margin.z !== undefined && !isNaN(+positionInfo.margin.z) ?
                                             +positionInfo.margin.z : 0}
                                         disabled={!handleData.hasCustomPosition}
                                         callBack={(value: number) => {
                                             changeHandleMargin('z', value);
                                         }}
                                         name="marginZ"
                                         viewControl={true}
                                         className={cnDetailSettingsMenu('Range')}
                                         showSlider={false}
                            />
                        </div>
                    </div>
                </div>
            </>}
        </div>);
    }